import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=5f4f3b53&"
import script from "./RegisterDialog.vue?vue&type=script&lang=ts&"
export * from "./RegisterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports